import { render } from "./MenikheimPage.vue?vue&type=template&id=8501b28e"
import script from "./MenikheimPage.vue?vue&type=script&lang=js"
export * from "./MenikheimPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__